<template>
  <!-- لا يوجد أي UI -->
  <div style="display:none"></div>
</template>

<script>
import Vue from 'vue'
import ProductSalesPrintLayout from './ProductSalesPrintLayout.vue'

export default {
  name: 'PrintProductSales',
  props: {
    mostSoldProducts: {
      type: Array,
      required: true
    },
    mostSoldSecondProducts: {
      type: Array,
      required: true
    },
    filters: {
      type: Object,
      required: true
    }
  },
  methods: {
    print() {
      const iframe = document.createElement('iframe')

      iframe.style.position = 'fixed'
      iframe.style.width = '0'
      iframe.style.height = '0'
      iframe.style.border = '0'

      document.body.appendChild(iframe)

      const doc = iframe.contentWindow.document

      doc.open()
      doc.write(`
        <html lang="ar" dir="rtl">
          <head>
            <title>Print</title>
            <style>
              ${this.printStyles()}
            </style>
          </head>
          <body>
            <div id="app"></div>
          </body>
        </html>
      `)
      doc.close()

      new Vue({
        render: h =>
          h(ProductSalesPrintLayout, {
            props: {
              mostSoldProducts: this.mostSoldProducts,
              mostSoldSecondProducts: this.mostSoldSecondProducts,
              filters: this.filters
            }
          })
      }).$mount(doc.getElementById('app'))

      setTimeout(() => {
        iframe.contentWindow.focus()
        iframe.contentWindow.print()

        setTimeout(() => {
          document.body.removeChild(iframe)
        }, 500)
      }, 500)
    },

    printStyles() {
      return `
        body {
          margin: 0;
          font-family: "Cairo", sans-serif;
        }

        .print-container {
          direction: rtl;
          padding: 24px;
          color: #000;
        }

        .header {
          text-align: center;
          margin-bottom: 16px;
        }

        .header h2 {
          margin: 0;
          font-size: 22px;
        }

        .meta {
          display: flex;
          justify-content: space-between;
          font-size: 13px;
          margin-top: 6px;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 16px;
        }

        th, td {
          border: 1px solid #333;
          padding: 8px;
          font-size: 13px;
          text-align: center;
        }

        thead {
          display: table-header-group;
        }

        tfoot {
          display: table-footer-group;
          font-weight: bold;
        }

        tr {
          page-break-inside: avoid;
        }

        @page {
          size: A4 portrait;
          margin: 15mm;
        }
      `
    }
  }
}
</script>
